import {Observable} from 'rxjs';
import {DataSource} from '@angular/cdk/collections';
import {map} from 'rxjs/operators';



/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class SubBudgetDataSource extends DataSource<any> {

    // The number of issues returned by github matching the query.
    public resultsLength = 0;
    public isLoadingResults = false;

    constructor(private observable) {
        super();
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]> {
        return this.observable.pipe(map((data: any) => {
            this.resultsLength = data.length;
            return data;
        }));

    }

    disconnect() {
    }

}

